import React from "react";
import HEXGlobe from "@icons/hexpert/HEXGlobe";
import './Document.scss';

type DocumentProps = {
  name: string;
  date?: string;
  size?: string;
  icon?: string;
  url?: string;
};

export const Document = ({ name, date, size, url }: DocumentProps) => {
  return (
    <div className="c-hex-doc-wrapper">
      <div className="c-hex-doc-image-wrapper">
        <HEXGlobe />
      </div>
      <a href={url} className="c-hex-doc-text-wrapper">
        <p className="c-hex-doc-title">{name}</p>
        <p className="c-hex-doc-info">
          {date} {size}
        </p>
      </a>
    </div>
  );
};
